export const clientValuationStatus = [
    {
        value: 1,
        name: 'Active Pre-valuation',
    },
    {
        value: 2,
        name: 'Active Mid-valuation',
    },
    {
        value: 3,
        name: 'Inactive',
    },
];

export const valuationMapper = id => {
    return clientValuationStatus.find(vs => vs.value === id) || null;
};
